import { render, staticRenderFns } from "./LoanPerformanceTotal.vue?vue&type=template&id=35fb9070&"
import script from "./LoanPerformanceTotal.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports